export const ButtonViewTypes = {
	Table: 'table',
	Chart: 'chart'
};


// WEBPACK FOOTER //
// ./src/views/components/button_views/buttonViewTypes.js